import React, { useEffect, useMemo, useState } from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
import { t } from 'Src/i18n';
import type { CriteriaForSearch } from 'Components/widgets/booking-breadcrumb/EditCriteria.utils';
import 'Components/widgets/booking-breadcrumb/EditCriteria.utils';
import { getBookingCriteriaDepartureCities } from 'Utils/booking-engine-pages/BookingPagesUtils';
import { useAppContext } from 'Context/ReactAppContext';
type HeaderCriteriaTransportPropsType = {
  criteria: CriteriaForSearch;
};
export const HeaderCriteriaTransport = ({ criteria }: HeaderCriteriaTransportPropsType) => {
  const appContext = useAppContext();
  const transportValue = criteria?.departureCity?.value;
  const [departureCitiesByProductId, setDepartureCitiesByProductId] = useState([]);
  useEffect(() => {
    // this is to get the translated version of the departure city
    getBookingCriteriaDepartureCities(criteria.search.value, appContext).then(
      ({ bookingCriteria: { departureCities } }) => {
        const formattedDepartureCities = departureCities.map(({ name, value }) => ({
          label: name,
          value,
        }));
        setDepartureCitiesByProductId(formattedDepartureCities);
      },
    );
  }, []);
  const selectedDepartureCity = useMemo(
    () => departureCitiesByProductId.find(({ value }) => value === transportValue),
    [transportValue, departureCitiesByProductId],
  );
  return (
    <div
      className="flex min-w-80 max-w-80 flex-1 items-center justify-center gap-10 rounded-8 border-1 border-solid border-white p-10 text-14 leading-1 text-white sm:flex-none md:max-w-none"
      data-testid="edit-my-criteria-transport"
    >
      <Icon width="1.25rem" name={transportValue !== 'NO' ? ICONS.TRANSPORT : ICONS.NO_TRANSPORT} />
      <span className="hidden sm:block">
        {selectedDepartureCity?.label || t('booking.priceDetails.packagePrice.noTransport')}
      </span>
    </div>
  );
};
